import React, { useState } from "react";
import "./Certificate.css";

const Certificate = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const certificates = [
    {
      img: "/Images/tour/Certificate/kuoni-france.gif",
    },
    {
      img: "/Images/tour/Certificate/kuoni-france.gif",
    },
    {
      img: "/Images/tour/Certificate/mp.gif",
    },
    {
      img: "/Images/tour/Certificate/dubai-expert.gif",
    },
    {
      img: "/Images/tour/Certificate/thailand.gif",
    },
    {
      img: "/Images/tour/Certificate/pinjab-pranav.gif",
    },
    {
      img: "/Images/tour/Certificate/punjab-sonali.gif",
    },
    {
      img: "/Images/tour/Certificate/botwsana.gif",
    },
    {
      img: "/Images/tour/Certificate/canada-inviotation.gif",
    },
    {
      img: "/Images/tour/Certificate/south-west-2.gif",
    },
    {
      img: "/Images/tour/Certificate/south-west.gif",
    },
    {
      img: "/Images/tour/Certificate/csp-2.gif",
    },
    {
      img: "/Images/tour/Certificate/csp-sonali.gif",
    },
    {
      img: "/Images/tour/Certificate/france-pranav.gif",
    },
    {
      img: "/Images/tour/Certificate/france-sonali.gif",
    },
    {
      img: "/Images/tour/Certificate/amadeus.gif",
    },
    {
      img: "/Images/tour/Certificate/trade-mark.gif",
    },
    {
      img: "/Images/tour/Certificate/Oman-JPG.gif",
    },
    {
      img: "/Images/tour/Certificate/adtoi.gif",
    },
  ];

  return (
    <section className="cert-wrapper">
      {/* Banner */}
      <div className="cert-banner">
        <h1>Our Certifications</h1>
        <p>Trusted • Certified • Recognized</p>
      </div>

      {/* Content */}
      <div className="cert-container">
        <div className="cert-grid">
          {certificates.map((item, index) => (
            <div
                className="cert-card"
                key={index}
                onClick={() => setSelectedImage(item.img)}
              >
              <div className="cert-img">
                <img src={item.img} alt={item.title} />
              </div>
              {/* <h3>{item.title}</h3> */}
            </div>
          ))}
        </div>
      </div>
      {selectedImage && (
        <div className="cert-modal" onClick={() => setSelectedImage(null)}>
          <img
            src={selectedImage}
            alt="Certificate"
            className="cert-modal-img"
          />
        </div>
      )}
    </section>
  );
};

export default Certificate;